import React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import { Outlet } from "react-router-dom";

import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from "@mui/material/useMediaQuery";
import { CollapseNavbarIcon } from "../../@lib/icons";
import { DrawerCloseContext } from "./drawerCloseContext";

export type DrawerLayoutProps = {
  drawerWidth?: number;
  drawerContent?: React.ReactNode;
  footerContent?: React.ReactNode;
};

const DrawerLayout: React.FC<DrawerLayoutProps> = (props) => {
  const { drawerWidth = 280, drawerContent, footerContent } = props;

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const closeDrawer = React.useCallback(() => setMobileOpen(false), []);

  return (
    <Box display={{ md: "flex" }}>
      {isSmallScreen && (
        <AppBar position="sticky" color="inherit" elevation={5}>
          <Toolbar>
            <IconButton
              edge="start"
              aria-label="open navigation menu"
              onClick={() => setMobileOpen(true)}
            >
              <CollapseNavbarIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
      )}
      <Drawer
        sx={{
          minWidth: 0,
          width: drawerWidth,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            border: "none",
          },
        }}
        PaperProps={{ elevation: 5 }}
        anchor="left"
        variant={isSmallScreen ? "temporary" : "permanent"}
        open={isSmallScreen ? mobileOpen : true}
        onClose={() => setMobileOpen(false)}
        ModalProps={{ keepMounted: true }}
      >
        <DrawerCloseContext.Provider value={closeDrawer}>
          {drawerContent}
        </DrawerCloseContext.Provider>
      </Drawer>
      <Box flexGrow={{ md: 1 }} minWidth={0}>
        <Outlet />
        {footerContent}
      </Box>
    </Box>
  );
};

export { DrawerLayout };
